import {I18n} from 'aws-amplify/utils';

import {SimplePageHeader,} from '@flexinet/ui-components';
import {useVerifiedPermissions} from "../../../hooks/useVerifiedPermissions.ts";
import {ReloadRecordsButton} from '../buttons/ReloadRecordsButton.tsx';
import {DeleteRecordButton} from "../buttons/DeleteRecordButton.tsx";
import {UploadButton} from "../buttons/UploadButton.tsx";
import {AddRecordButton} from "../buttons/AddRecordButton.tsx";
import {config} from "../config";


const useTools = () => {

    const {allowedActions} = useVerifiedPermissions()

    const tools = [<ReloadRecordsButton key='reload'/>];

    if (allowedActions.includes('DeleteDomainName')) {
        tools.push(<DeleteRecordButton key='delete'/>);
    }

    if (allowedActions.includes('BulkImportDomainNames')) {
        tools.push(<UploadButton/>);
    }

    if (allowedActions.includes('CreateDomainName')) {
        tools.push(<AddRecordButton key='add'/>);
    }


    return tools;
};

export const IndexPageHeader = () => {
    return (
        <SimplePageHeader
            title={I18n.get(config.titles.plural)}
            tools={useTools()}
        />
    );
};
